import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { setAlert } from '../../store/alert';
import { isName, isEmail, isPhone, isPassword } from '../../utils/fn';
import fetch from '../../utils/fetch';
import icons from '../../utils/icons.json';

function Signup() {
	const dispatch = useDispatch();
	const navigate = useNavigate()
	useDocumentTitle('Create Account');
	const webSettings = useSelector(state => state.webSettings.data);

	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [phone, setPhone] = useState('');
	const [location, setLocation] = useState('');

	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);
	const [error, setError] = useState('');

	const body = `<head><style>
							table {
								border-collapse: collapse;
								border: 1px solid #000000;
							}
							table td,
							table th{
								text-align: start;
								padding: 10px;
								border: 1px solid #000000;
							}
						</style></head>
						<body><table>
							<thead>
								<tr>
									<th colspan="2">Account Details</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<th>Full Name</th>
									<td>${name}</td>
								</tr>
								<tr>
									<th>Phone Number</th>
									<td>${phone}</td>
								</tr>
								<tr>
									<th>Email Address</th>
									<td>${email}</td>
								</tr>
								<tr>
									<th>Location</th>
									<td>${location}</td>
								</tr>
								<tr>
									<th>Date</th>
									<td>${new Date().toLocaleString()}</td>
								</tr>
								<tr>
									<th>Status</th>
									<td>Pending</td>
								</tr>
							</tbody>
						</table></body>`;

	function submit(e) {
		e.preventDefault();
		if (loading) return;
		let res;
		if ((res = isName(name)) === true) {
			if ((res = isPhone(phone)) === true) {
				if ((res = isEmail(email)) === true) {
					if (location.length > 3 && location.length < 30) {
						setLoading(true);
						fetch
							.get('requestCustomerAccount', {
								customerEmail: email,
								contactPhone: phone,
								messageBody: body,
							})
							.then(res => {
								console.log(res.list[0]);
								setLoading(false);
								if (res.list.length > 0) {
									setResponse(res.list[0]);
								} else {
									dispatch(setAlert({ type: 'error', message: 'An error occurred while requesting for account', duration: 10000 }));
								}
							})
							.catch(err => {
								setLoading(false);
								setError(err.message);
								dispatch(setAlert({ type: 'error', message: err.message }));
								console.log(err);
							});
						return;
					} else {
						res = 'Enter a valid location name.';
					}
				}
			}
		}
		if (res) {
			dispatch(setAlert({ type: 'error', message: res }));
		}
	}
	return (
		<>
			<div className='sign-window shadow'>
				<div className='head'>
					<img className='logo' src={webSettings && webSettings.WEB_SITE_LOGO} alt='' />
					<h2>
						Account
						<br />
						Request
					</h2>
				</div>
				<form className='body' onSubmit={submit}>
					<input onInput={e => setName(e.target.value)} value={name} className='input' type='text' id='name' placeholder='Full Name' />
					<input onInput={e => setPhone(e.target.value)} value={phone} className='input' type='tel' id='phone' placeholder='Phone Number' />
					<input onInput={e => setEmail(e.target.value.trim())} value={email} className='input' type='email' id='email' placeholder='Email Address' />
					<input onInput={e => setLocation(e.target.value)} value={location} className='input' type='test' id='location' placeholder='Your Location' />
					<button className='btn' type='submit'>
						{loading ? 'Loading...' : 'Request Account'}
					</button>
				</form>
				<div className='foot'>
					<p className=''>
						Already have account? <Link to='/signin'>Sign In</Link>
					</p>
				</div>
				{/* <p style={{ padding: '10px' }} dangerouslySetInnerHTML={{ __html: body }}></p> */}
			</div>
			{!loading && response && (
				<div className='top-window checkout-window'>
					<div className='inner-window'>
						<span className='icon' dangerouslySetInnerHTML={{ __html: icons.check_circle }}></span>
						<h2>SUCCESS</h2>
						<h3>Account Requested</h3>
						<p style={{ margin: '20px auto' }}>You will receive an email with your account details on successful account creation.</p>
						<button onClick={() => navigate('/products-and-services')} type='button' className='btn success'>
							Back
						</button>
					</div>
				</div>
			)}
		</>
	);
}

export default React.memo(Signup);
